<template>
  <div
    class="offer"
    :class="[defineSize, offerType]"
  >
    <div
      v-if="offerType"
      class="tag-wrapper tag-wrapper--offer"
      :class="offerType"
    >
      <svgicon
        v-if="offerType == 'Regular'"
        name="Logos/Stammis-Red"
        class="stammis-icon"
        :original="true"
      />
      <div
        v-if="offerType == 'Coupon'"
        class="tags"
        :class="labelSize ? '' : 'tags-sm'"
      >
        <span v-text="'Kupong'" />
      </div>
      <svgicon
        v-if="offerType == 'Coupon'"
        :name="labelSize ? 'Misc/LabelAngle40' : 'Misc/LabelAngle24'"
        class="angle-right"
      />
    </div>
    <epi-property
      v-if="offerType"
      id="offerType"
      text="Ändra typ"
    />
    <div class="offer__info-wrapper">
      <button
        class="button--transparent center--content show-info"
        @click="toggleModal"
      >
        <span class="offer__info-text">Mer info</span>
        <svgicon
          name="Alerts/Info"
          class="offer__info-icon"
        />
      </button>
    </div>

    <section class="offer__content-wrapper">
      <div
        class="offer__image-wrapper"
        :class="imageSize"
      >
        <epi-picture
          :image="image"
          :sizes="dimensions"
          :sharpen="80"
          auto-quality="best"
          :use-picture="true"
        />
        <epi-property
          id="Image"
          class="background-edit-button"
          text="Ändra erbjudande bild"
        />
      </div>
      <div class="offer__content">
        <h3
          v-if="title || isEditable"
          v-edit="'Title'"
          v-text="title"
        />

        <div
          v-if="price || isEditable"
          class="offer__price"
        >
          <p
            v-edit="'Price'"
            v-text="price"
          />
        </div>
        <div class="offer__rules">
          <p
            v-if="description || isEditable"
            v-edit="'Description'"
          >
            {{ description }}
          </p>
          <p v-if="dateFrom.startsWith('2') || isEditable">
            Gäller <span v-edit="'DateFrom'">{{ dateFormat(dateFrom) }}</span>-<span v-edit="'DateTo'">{{ dateFormat(dateTo) }}</span>
          </p>
        </div>
        <button
          v-if="buttonLabel"
          v-edit="'ButtonLabel'"
          class="button--40 button--text-icon"
        >
          <svgicon
            v-if="offerType == 'Coupon'"
            name="Shop/Coupon"
            class="offer__percent-icon"
          />
          <svgicon
            v-else
            name="Misc/Placeholder"
            class="offer__percent-icon"
          />{{ buttonLabel }}
        </button>
      </div>
    </section>
    <ica-modal
      v-if="articles"
      v-model="active"
      :title="type"
      :z-index="200"
    >
      <template #content>
        <div class="offer-modal">
          <div class="row-middle offer-modal__info">
            <div class="offer-modal__image-wrapper">
              <epi-picture
                :image="image"
                :sizes="dimensions"
                :sharpen="80"
                auto-quality="best"
                :use-picture="true"
              />
            </div>
            <div class="col-6 product-info">
              <h3
                v-if="title"
                class="product-info__heading font-rubrik-1--mid font-fixed"
              >
                {{ title }}
              </h3>
              <div
                v-if="price"
                class="product-info__price"
              >
                {{ price }}
              </div>
              <div class="product-info__rules">
                <p v-if="description">
                  {{ description }}
                </p>
                <p v-if="dateFrom.startsWith('2') || isEditable">
                  Gäller <span>{{ dateFormat(dateFrom) }}</span>-<span>{{ dateFormat(dateTo) }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="offer-modal__more-info">
            <h4 class="offer-modal__heading">
              Mer info
            </h4>
            <p
              v-if="info"
              class="offer-modal__more-info-description"
            >
              {{ info }}
            </p>
          </div>
          <div
            v-if="articles.length"
            class="offer-modal__offers-included"
          >
            <h4 class="offer-modal__heading">
              Varor som ingår
            </h4>
            <ul class="offer-list">
              <li
                v-for="({ key, value }, index) in articles"
                :key="index"
              >
                <p>{{ key }}</p>
                <p class="detail">
                  {{ value }}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </template>
      <template
        v-if="buttonLabel"
        #footer
      >
        <button class="button--40 button--text-icon button--fullwidth">
          <svgicon
            v-if="offerType == 'Coupon'"
            name="Shop/Coupon"
            class="offer__percent-icon"
          />
          <svgicon
            v-else
            name="Misc/Placeholder"
            class="offer__percent-icon"
          />{{ buttonLabel }}
        </button>
      </template>
    </ica-modal>
  </div>
</template>

<script>
import IcaModal from "~/@ica/ica-molecules-vue/dist/Modal"
import format from "dateformat"
import "#/Shop/Coupon"
import "#/Misc/Placeholder"
import "#/Logos/Stammis-Red"
import "#/Misc/LabelAngle40"
import "#/Misc/LabelAngle24"
import "#/Alerts/Info"

export default {
  name: "OfferBlock",
  components: {
    IcaModal
  },
  props: {
    blockSize: {
      type: String,
      default: "",
      validator (value) {
        return ["", "full", "half", "third", "quarter"].includes(value)
      }
    },
    type: {
      type: String,
      default: "Erbjudande"
    },
    title: {
      type: String,
      default: ""
    },
    dateTo: {
      type: String,
      default: ""
    },
    dateFrom: {
      type: String,
      default: ""
    },
    buttonLabel: {
      type: String,
      default: ""
    },
    offerType: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    info: {
      type: String,
      default: ""
    },
    price: {
      type: String,
      default: ""
    },
    image: {
      type: Object,
      default: () => {}
    },
    articles: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      active: false,
      dimensions: {
        small: {
          width: 200
        },
        medium: {
          width: 240
        },
        large: {
          width: 472
        }
      }
    }
  },
  computed: {
    size () {
      return this.isEditable ? "full" : this.blockSize
    },
    defineSize () {
      return this.size.toLowerCase()
    },
    couponType () {
      return this.coucouponDetails ? this.coucouponDetails.offerType : null
    },
    imageSize () {
      if (this.size.toLowerCase() == "full") {
        return "col-12_md-6"
      } else if (this.size.toLowerCase() == "half") {
        return "col-12_md-6_lg-12_xl-6"
      } else {
        return ""
      }
    },
    labelSize () {
      return this.size.toLowerCase() == "full" &&
        this.$root.currentSizeGte("lg")
        ? true
        : false
    }
  },
  methods: {
    toggleModal () {
      this.active = !this.active
    },
    dateFormat: date => {
      return format(new Date(date), "d/m")
    }
  }
}
</script>

<style lang="scss">
.offer {
  $this: &;

  position: relative;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  border-radius: 0.25rem;
  height: 100%;

  &.coupon {
    border: 0.125rem dashed $color-pink-light;
  }

  .center--content {
    display: flex;
    align-items: center;
    flex-grow: 1;
  }

  .button--transparent {
    padding-right: 0;
    padding-top: 0;
  }

  &__info-wrapper {
    position: absolute;
    right: 0.5rem;
    top: 0.5rem;
  }

  &__info-icon {
    width: 1.5rem;
    height: 1.5rem;
    fill: $color-secondary-cta-text;
  }

  &__info-text {
    display: none;
    color: $color-secondary-cta-text;
    margin-right: 0.5rem;

    @include font(text, 3, "bold");

    @include media-breakpoint-up(md) {
      display: inline-flex;
    }

    .quarter & {
      @include media-breakpoint-up(lg) {
        display: none;
      }

      @include media-breakpoint-up(xl) {
        display: inline-flex;
      }
    }
  }

  .angle-right {
    width: 1.25rem;
    margin-left: -0.0625rem;
  }

  .tag-wrapper {
    position: absolute;
    left: 0;
    top: 0.5rem;
    z-index: 2;

    &.Regular {
      top: 1rem;
      left: 1rem;

      .stammis-icon {
        min-width: 6.6875rem;
        max-width: 10.125rem;
      }
    }
  }

  &.half {
    .tag-wrapper {
      top: 1rem;

      &.Regular {
        @include media-breakpoint-up(md) {
          width: 7.5938rem;
          top: 1.5rem;
          left: 1.5rem;
        }

        .stammis-icon {
          @include media-breakpoint-up(md) {
            width: 7.5938rem;
          }
        }
      }
    }
  }

  &.full {
    @include media-breakpoint-up(xl) {
      max-height: 36.5rem;
    }

    .tag-wrapper {
      top: 1rem;

      &.Regular {
        @include media-breakpoint-up(md) {
          top: 1.5rem;
          left: 1.5rem;
        }

        .stammis-icon {
          @include media-breakpoint-up(md) {
            width: 7.5938rem;
          }

          @include media-breakpoint-up(lg) {
            width: 10.125rem;
          }
        }
      }
    }

    .angle-right {
      @include media-breakpoint-up(lg) {
        width: 2.25rem;
      }
    }
  }

  .ie11 & .tag-wrapper {
    max-height: 24px;

    & .tags-sm {
      max-height: 24px;
    }

    & .angle-right {
      width: 1.25rem;
      height: 1.5rem;
      margin-left: -0.0625rem;
    }
  }
  // Content-wrapper

  &__content-wrapper {
    align-items: center;
    padding: 2rem 1rem;
    display: flex;
    flex-grow: 1;
    flex-direction: row;
    background-color: $color-white;
    border-radius: 0.25rem;
    box-shadow: $box-shadow-primary;

    .full &,
    .half & {
      flex-direction: column;
      margin: auto 0;
      justify-content: space-between;
      padding: 1.5rem 3.5rem 2.5rem;
    }

    @include media-breakpoint-up(md) {
      padding: 1.25rem 8rem 1.25rem 3.5rem;

      .full &,
      .half & {
        flex-direction: row;
        padding: 3.25rem 6rem;
      }
    }

    @include media-breakpoint-up(lg) {
      justify-content: space-between;
      padding: 2.5rem 1rem;
      flex-direction: column;

      .third & {
        padding: 2.5rem 1.5rem;
      }

      .half & {
        padding: 2rem 6.5rem 3rem;
        flex-direction: column;
      }

      .full & {
        padding: 5.5rem 5.5rem;
      }
    }

    @include media-breakpoint-up(xl) {
      padding: 2.5rem 2rem;

      .third & {
        padding: 2.5rem 3rem;
      }

      .half & {
        flex-direction: row;
        padding: 8.25rem 3rem;
      }

      .full & {
        padding: 4.5rem 8.5rem;
      }
    }
  }

  // Image wrapper

  &__image-wrapper {
    max-width: 7.375rem;
    min-width: 7.375rem;
    margin-right: 1rem;
    padding: 0;

    .full &,
    .half & {
      max-width: 12.4375rem;
      margin-bottom: 1rem;
      margin-right: 0;
      padding: 0;
    }

    @include media-breakpoint-up(md) {
      max-width: 10rem;
      margin-right: 2rem;

      .full &,
      .half & {
        margin-bottom: 0;
        margin-right: 3.5rem;
        max-width: 15rem;
      }
    }

    @include media-breakpoint-up(lg) {
      margin-bottom: 2.5rem;
      margin-right: 0;

      .third & {
        max-width: 11.5rem;
        margin-right: 0;
      }

      .quarter & {
        max-width: 11.5rem;
        margin-bottom: 3.25rem;
      }

      .half & {
        max-width: 13.0625rem;
        margin-right: 0;
        margin-bottom: 2rem;
      }

      .full & {
        margin-right: 2rem;
        max-width: 25.5rem;
      }
    }

    @include media-breakpoint-up(xl) {
      margin-bottom: 2.5rem;

      .half & {
        max-width: 16rem;
        margin-right: 1rem;
        margin-bottom: 0;
        padding: 1rem;
      }

      .full & {
        margin-right: 4.5rem;
        max-width: 29.5rem;
      }
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    padding-bottom: 0;
    flex-grow: 1;
    text-align: center;

    .third &,
    .quarter & {
      text-align: left;

      @include media-breakpoint-up(md) {
        padding: 0.75rem 0;
        text-align: left;

        .button--40 {
          margin: auto 0 0;
        }

        .full &,
        .half & {
          padding: 1rem 0;
        }
      }

      @include media-breakpoint-up(lg) {
        text-align: center;

        .button--40 {
          margin: auto auto 0;
        }

        .full &,
        .half & {
          .button--40 {
            margin: 0 auto 0;
          }
        }
      }
    }

    @include media-breakpoint-up(md) {
      max-width: 100%;
    }

    &[class*="col-"] {
      padding-bottom: 0;
    }

    .full & {
      max-width: 100%;
      flex-grow: 1;
    }

    .button--40 {
      width: 100%;
      margin: auto auto 0;

      @include media-breakpoint-up(md) {
        width: fit-content;
      }
    }

    @include media-breakpoint-up(lg) {
      min-height: 13.5rem;

      .half & {
        min-height: 12.5rem;
        margin-right: 1rem;
      }
    }

    h3 {
      font-weight: 500;
      letter-spacing: 0;
      margin: 0;

      @include font(rubrik, 2, "mid");

      .half & {
        @include media-breakpoint-up(md) {
          @include font(rubrik, 4, "mid");
        }

        @include media-breakpoint-up(lg) {
          @include font(rubrik, 3, "mid");
        }
      }

      .full & {
        @include font(rubrik, 3, "mid");

        @include media-breakpoint-up(md) {
          @include font(rubrik, 4, "mid");
        }
      }
    }

    & #{$this}__price {
      margin-bottom: 0.5rem;

      .full & {
        @include media-breakpoint-up(lg) {
          margin-bottom: 1.5rem;
        }
      }

      p {
        margin: 0;
        letter-spacing: 0;
        color: $color-red;

        @include font(rubrik, 2, "black");

        @include media-breakpoint-up(sm) {
          @include font(rubrik, 3, "black");
        }

        .half & {
          @include media-breakpoint-up(md) {
            @include font(rubrik, 6, "black");
          }

          @include media-breakpoint-up(lg) {
            @include font(rubrik, 3, "black");
          }
        }

        .full & {
          @include font(rubrik, 3, "black");

          @include media-breakpoint-up(md) {
            @include font(rubrik, 6, "black");
          }
        }
      }
    }

    & #{$this}__rules {
      margin-bottom: 1rem;

      .full &,
      .half & {
        margin-bottom: 2.5rem;
      }

      @include media-breakpoint-up(md) {
        margin-bottom: 0.75rem;

        .full &,
        .half & {
          margin-bottom: 2rem;
        }
      }

      @include media-breakpoint-up(lg) {
        .full &,
        .half & {
          margin-bottom: 2.5rem;
        }
      }

      p {
        color: $color-secondary-text;
        margin: 0 auto;

        @include font(text, 2, "normal");

        @include media-breakpoint-up(lg) {
          @include font(text, 3, "normal");
        }

        .full & {
          @include media-breakpoint-up(lg) {
            @include font(text, 4, "normal");
          }
        }
      }
    }

    @include media-breakpoint-up(lg) {
      .full & {
        .button--40 {
          margin: 0 auto 0;
        }
      }
    }

    @include media-breakpoint-up(xl) {
      .half & {
        .button--40 {
          margin: 0 auto 0;
        }
      }
    }
  }

  .offer-list {
    width: 100%;
    margin-bottom: 1.5rem;

    li {
      border-top: 0.0625rem solid $color-grey-special;
      padding: 0.875rem 1rem;
      display: flex;
      justify-content: space-between;

      @include media-breakpoint-up(md) {
        padding: 0.875rem 1.5rem;
      }

      &:last-of-type {
        border-bottom: none;
      }

      p {
        text-align: left;
        margin: 0;

        &.detail {
          @include font(text, 2, "light");
        }
      }
    }
  }

  .modal-content {
    padding: 0;
  }

  .offer-modal {
    &__heading,
    &__more-info-description,
    &__instructions {
      padding: 0 1rem;

      @include media-breakpoint-up(md) {
        padding: 0 1.5rem;
      }
    }

    &__heading {
      margin: 0.5rem 0;
    }

    .product-info {
      &__heading {
        margin: 0;
      }

      &__price {
        color: $color-red;

        @include font(rubrik, 1, "black");

        @include media-breakpoint-up(sm) {
          @include font(rubrik, 2, "black");
        }
      }

      &__rules {
        p {
          margin: 0;
        }
      }
    }

    &__info {
      padding: 2rem 1rem 1rem;
      margin: 1rem;
      border: 1px solid $color-grey-special;
      border-radius: 0.25rem;

      @include media-breakpoint-up(md) {
        padding: 1rem 1.5rem;
      }
    }

    &__image-wrapper {
      .epi-picture {
        max-width: 7.375rem;
        max-height: 7.375rem;
        margin-right: 0.5rem;
        min-width: 7.375rem;
        text-align: center;

        @include media-breakpoint-up(md) {
          margin-right: 1rem;
        }

        img {
          max-width: 100%;
          max-height: 7.375rem;
        }
      }
    }

    &__more-info {
      h4 {
        border-bottom: 0.0625rem solid $color-grey-special;
        padding-bottom: 0.5rem;
      }
    }

    &__more-info-description {
      margin: 0 0 1.5rem;
    }

    &__instructions {
      margin: 1rem 0;
    }
  }
}
</style>
